import type { ConnectionTest } from "./types";

export function isBlankConnectionTestUrl(url: string): boolean {
  return !url.trim();
}

export function connectionTestWouldSkip(
  connectionTest: ConnectionTest | undefined,
  configuration: Record<string, string>
): boolean {
  if (!connectionTest) return false;
  try {
    const rendered =
      connectionTest.protocol === "http"
        ? connectionTest.request(configuration)
        : connectionTest.connectionString(configuration);
    const url = typeof rendered === "string" ? rendered : rendered.url;
    return isBlankConnectionTestUrl(url);
  } catch {
    return false;
  }
}

// Filled placeholders make config-derived targets render, so only a hardcoded
// empty URL still skips.
const FILLED_CONFIGURATION = new Proxy(
  {},
  { get: () => "https://sentinel.invalid" }
) as Record<string, string>;

export function connectionTestAlwaysSkips(
  connectionTest: ConnectionTest | undefined
): boolean {
  return connectionTestWouldSkip(connectionTest, FILLED_CONFIGURATION);
}
